let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5485f")).then(() => parcelRequire('24N9u'));